import React from 'react';
import { connect } from 'react-redux';

import PopupButton from 'apps/auth/components/common/Popup/PopupButton';
import SimplePopup from 'apps/auth/components/common/Popup/SimplePopup';
import { CANADA, USA } from 'apps/auth/constants/WellKnownCountries';

const TermsAgreePopup = (props) => {
    const getHeader = (props) => {
        return (
            <>
                {props.countryId === USA && props.usaTermsDisclaimerModalText}
                {props.countryId === CANADA && props.termsDisclaimerModalText}
                {props.countryId !== CANADA && props.countryId !== USA && props.defaultTermsDisclaimerModalText}
            </>
        );
    };

    return (
        <SimplePopup text={getHeader(props)} popupRef={props.popupRef}>
            <PopupButton
                dataTestId="agree-popup-link-agree"
                iconName="check"
                text={props.disclaimerSubmit}
                onClick={(e) => {
                    e.preventDefault();
                    props.submitRef.current.click();
                    props.popupRef.current?.close();
                }}
            />
            <PopupButton
                dataTestId="agree-popup-link-cancel"
                iconName="cross"
                text={props.buttonCancel}
                onClick={(e) => {
                    props.popupRef.current?.close();
                    e.preventDefault();
                }}
            />
        </SimplePopup>
    );
};
const mapStateToProps = (state) => {
    return {
        countryId: state.auth.countryId,
        termsDisclaimerModalText: state.messages.pageMessages.termsDisclaimerModalText,
        usaTermsDisclaimerModalText: state.messages.pageMessages.usaTermsDisclaimerModalText,
        defaultTermsDisclaimerModalText: state.messages.pageMessages.defaultTermsDisclaimerModalText,
        disclaimerSubmit: state.messages.pageMessages.disclaimerSubmit,
        buttonCancel: state.messages.pageMessages.buttonCancel,
    };
};
export default connect(mapStateToProps, null)(TermsAgreePopup);
